import React, { useState } from 'react';
import api from '../../api/axiosConfig';
import './OneDriveAdmin.css';
import UploadZone from '../ZonaDeSubida/ZonaDeSubida';
import FilePreviewModal from '../FilePreviewModal/FilePreviewModal';
import { detectarTabKey } from '../../config/folderRoutes';

const n = (name) => name?.replace(/^\d{2}\s*-\s*/, '') || name;

const getFileIcon = (filename) => {
  if (!filename) return 'bi bi-file-earmark';
  const parts = filename.split('.');
  if (parts.length === 1) return 'bi bi-file-earmark';
  const extension = parts.pop().toLowerCase();
  switch (extension) {
    case 'pdf': return 'bi bi-filetype-pdf';
    case 'doc':
    case 'docx': return 'bi bi-filetype-docx';
    case 'xls':
    case 'xlsx':
    case 'csv': return 'bi bi-filetype-xlsx';
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif': return 'bi bi-filetype-jpg';
    case 'zip':
    case 'rar': return 'bi bi-file-zip';
    default: return 'bi bi-file-earmark';
  }
};

const getFileIconColor = (filename) => {
  if (!filename) return '#718096';
  const parts = filename.split('.');
  if (parts.length === 1) return '#718096';
  const extension = parts.pop().toLowerCase();
  switch (extension) {
    case 'pdf': return '#e53e3e';
    case 'doc':
    case 'docx': return '#2b6cb0';
    case 'xls':
    case 'xlsx':
    case 'csv': return '#38a169';
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif': return '#805ad5';
    case 'zip':
    case 'rar': return '#d69e2e';
    default: return '#718096';
  }
};

const OneDriveAdmin = ({ crearNotificacion, notificaciones, addToast, entidadCuit, entidadId, tabKey }) => {
  const [history, setHistory] = useState([]);
  const [carpetaActual, setCarpetaActual] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewFile, setPreviewFile] = useState(null);

  React.useEffect(() => {
    if (!carpetaActual && history.length === 0) {
      abrirCarpeta('ROOT_GLOBAL', 'Raiz OneDrive');
    }
  }, []);


const handleSubirArchivo = async (e) => {
  const files = e.target ? e.target.files : e; 
  if (!files || files.length === 0) return;

  let file = files[0];
  const nombresExistentes = (carpetaActual?.contenido || [])
    .filter(item => item.tipo === 'Archivo')
    .map(item => item.nombre);

  let nombreFinal = file.name;
  if (nombresExistentes.includes(nombreFinal)) {
    const base = file.name.replace(/(\.[^.]+)$/, '');
    const ext = file.name.match(/(\.[^.]+)$/)?.[1] || '';
    let counter = 1;
    while (nombresExistentes.includes(`${base} (${counter})${ext}`)) {
      counter++;
    }
    nombreFinal = `${base} (${counter})${ext}`;
    file = new File([file], nombreFinal, { type: file.type });
  }

  const formData = new FormData();
  formData.append('archivo', file); 

  try {
    setLoading(true);
    
    const response = await api.post(`/subirArchivo?carpetaId=${carpetaActual.id}`, formData);

    if (response.status === 200) {
      if (addToast) addToast(`Archivo subido: ${nombreFinal}`, 'success');
      await abrirCarpeta(carpetaActual.id, carpetaActual.nombre, true);
    }
  } catch (err) {
    console.error("Error:", err);
    if (addToast) addToast('Error al subir el archivo', 'error');
  } finally {
    setLoading(false);
  }
};



  const abrirCarpeta = async (id, nombre, isGoBack = false) => {
    setLoading(true);
    setError('');
    try {
      const endpoint = id === 'ROOT_GLOBAL' ? '/carpetaRaiz' : `/obtenerCarpetaPorId?carpetaId=${id}`;
      const response = await api.get(endpoint);
      const data = response.data;

      if (!isGoBack && carpetaActual) {
        setHistory(prev => [...prev, { id: carpetaActual.id, nombre: carpetaActual.nombre }]);
      }

      setCarpetaActual({
        id: data.folderId || id,
        nombre: nombre,
        contenido: data.contenido_actual || []
      });
    } catch (err) {
      console.error("Error al obtener la carpeta", err);
      if (!isGoBack && carpetaActual) {
        setHistory(prev => [...prev, { id: carpetaActual.id, nombre: carpetaActual.nombre }]);
      }
      setCarpetaActual({
        id: id,
        nombre: nombre,
        contenido: []
      });
      setError('No se pudo cargar el contenido desde el servidor. Mostrando carpeta vacia.');
    } finally {
      setLoading(false);
    }
  };

  const handleVolver = () => {
    if (history.length > 0) {
      const previousFolder = history[history.length - 1];
      setHistory(prev => prev.slice(0, -1));
      abrirCarpeta(previousFolder.id, previousFolder.nombre, true);
    }
  };

  const handleItemClick = (item) => {
    if (item.tipo === 'Carpeta') {
      abrirCarpeta(item.id, item.nombre);
    } else {
      handlePrevisualizarArchivo(item);
    }
  };

  const handleEliminarArchivoLocal = async (archivoId) => {
    if (!window.confirm('Estas seguro?')) return;
    const nombre = carpetaActual?.contenido?.find(i => i.id === archivoId)?.nombre || '';

    try {
      const response = await api.delete(`/eliminarArchivo?archivoId=${archivoId}`);

      if (response.status === 200) {
        if (addToast) addToast(`Archivo eliminado: ${nombre}`, 'error');
        await abrirCarpeta(carpetaActual.id, carpetaActual.nombre, true);
      }
    } catch (error) {
      console.error(error);
      if (addToast) addToast('Error al eliminar el archivo', 'error');
    }
  };

  const handleNotificarCliente = async (item) => {
    if (!carpetaActual) return;
    if (!entidadCuit) {
      if (addToast) addToast('No se puede notificar: selecciona una entidad con CUIT.', 'warning');
      return;
    }
    try {
      const folderPath = [...history, { id: carpetaActual.id, nombre: carpetaActual.nombre }];
      const effectiveTabKey = tabKey || detectarTabKey(folderPath) || 'onedrive-global';
      await api.post('/notificarArchivoNuevo', {
        ...(entidadId ? { entidadId } : { cuitUser: entidadCuit }),
        archivoNombre: item.nombre,
        carpetaNombre: n(carpetaActual.nombre),
        carpetaRealId: carpetaActual.id,
        tabKey: effectiveTabKey,
        folderPath
      });
      if (addToast) addToast(`Notificado: ${item.nombre}`, 'success');
    } catch { if (addToast) addToast('Error al notificar.', 'warning'); }
  };

  const handleDescargarArchivo = async (archivo) => {
    try {
      const response = await api.get(`/descargarArchivo?archivoId=${archivo.id}`);
      const urlDescarga = response.data.url || response.data.downloadUrl;

      if (urlDescarga) {
        const link = document.createElement('a');
        link.href = urlDescarga;
        link.setAttribute('download', archivo.nombre || 'documento');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('El servidor no devolvio una URL de descarga valida.');
      }
    } catch (error) {
      console.error("Error al obtener el link de descarga:", error);
    }
  };

  const handlePrevisualizarArchivo = async (archivo) => {
    try {
      setPreviewFile(archivo);
      setPreviewUrl('');
      setPreviewModalOpen(true);
      
      const response = await api.get(`/previsualizarArchivo?archivoId=${archivo.id}`);
      if (response.data && response.data.url) {
        setPreviewUrl(response.data.url);
      } else {
        alert("No se pudo obtener la vista previa del archivo.");
        setPreviewModalOpen(false);
      }
    } catch (error) {
      console.error("Error al obtener la vista previa:", error);
      alert("Hubo un error al intentar abrir la vista previa.");
      setPreviewModalOpen(false);
    }
  };



  const SkeletonLoader = () => (
    <div className="skeleton-container">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="skeleton-item">
          <div className="skeleton-left">
            <div className="skeleton-icon"></div>
            <div className="skeleton-text-container">
              <div className="skeleton-text-main" style={{ width: `${Math.random() * 30 + 30}%` }}></div>
              <div className="skeleton-text-sub" style={{ width: `${Math.random() * 20 + 15}%` }}></div>
            </div>
          </div>
          <div className="skeleton-right">
            <div className="skeleton-action"></div>
            <div className="skeleton-action"></div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="carpeta-personal-container">
      <div className="carpeta-personal-header">
        {history.length > 0 && (
          <button className="btn-volver" onClick={handleVolver} disabled={loading}>
            <i className="bi bi-arrow-left"></i> Volver ({n(history[history.length - 1].nombre)})
          </button>
        )}
        {carpetaActual ? (
          <h2>{n(carpetaActual.nombre)}</h2>
        ) : (
          <h2>Acceso Global (OneDrive)</h2>
        )}
      </div>

      {error && (
        <div style={{ backgroundColor: '#fef2f2', color: '#b91c1c', padding: '10px', borderRadius: '6px', marginBottom: '15px', fontSize: '14px' }}>
          <i className="bi bi-exclamation-triangle" style={{ marginRight: 8 }}></i>
          {error}
        </div>
      )}

      {loading ? (
        <div className="carpeta-detalle">
          <div className="carpeta-detalle-header">
            <h3 style={{ color: '#e2e8f0', width: '200px', height: '24px', backgroundColor: '#e2e8f0', borderRadius: '4px', animation: 'pulse 1.5s infinite ease-in-out' }}> </h3>
            <p style={{ color: '#e2e8f0', width: '100px', height: '16px', backgroundColor: '#e2e8f0', borderRadius: '4px', animation: 'pulse 1.5s infinite ease-in-out', marginTop: '8px' }}> </p>
          </div>
          <UploadZone loading={loading} />
          <div className="archivos-list">
            <h4>Contenido</h4>
            <SkeletonLoader />
          </div>
        </div>
      ) : !carpetaActual ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
          No hay carpeta seleccionada.
        </div>
      ) : (
        <div className="carpeta-detalle">
          <div className="carpeta-detalle-header">
            <h3><i className="bi bi-folder-open" style={{ marginRight: 8, color: '#1a3c5e' }}></i> Explorando: {n(carpetaActual.nombre)}</h3>
            <p>Directorio actual</p>
          </div>

          <UploadZone onSubir={handleSubirArchivo} loading={loading} />

          <div className="archivos-list">
            <h4>Contenido</h4>
            {carpetaActual.contenido.length === 0 ? (
              <div className="empty-state">La carpeta esta vacia.</div>
            ) : (
              <ul className="lista-items">
                {carpetaActual.contenido.map((item) => (
                  <li key={item.id} className="archivo-item" style={{ cursor: 'pointer', transition: 'background-color 0.2s' }} onClick={() => handleItemClick(item)}>
                    <div className="archivo-info-izquierda">
                      <span className="file-type-icon">
                        {item.tipo === 'Carpeta' 
                          ? <i className="bi bi-folder" style={{ color: '#2a5a8a', fontSize: '1.5rem' }}></i>
                          : <i className={getFileIcon(item.nombre)} style={{ color: getFileIconColor(item.nombre), fontSize: '1.5rem' }}></i>
                        }
                      </span>
                      <div className="archivo-textos">
                        <div className="archivo-nombre" style={{ color: item.tipo === 'Carpeta' ? '#2a5a8a' : '#334155', fontWeight: item.tipo === 'Carpeta' ? '600' : '400' }}>
                          {n(item.nombre)}
                        </div>
                        <div className="archivo-meta">
                          {item.tipo} {item.size ? `- ${item.size}` : ''} {item.fecha ? `- ${item.fecha}` : ''}
                        </div>
                      </div>
                    </div>

                    <div className="archivo-acciones" onClick={(e) => e.stopPropagation()}>
                      {item.tipo === 'Archivo' && (
                        <>
                          <button
                            className="btn-accion btn-descargar"
                            title="Descargar"
                            onClick={() => handleDescargarArchivo(item)}
                          >
                            <i className="bi bi-download"></i>
                          </button>

                          <button
                            className="btn-accion btn-notificar"
                            title="Notificar al cliente"
                            onClick={() => handleNotificarCliente(item)}
                          >
                            <i className="bi bi-send"></i>
                          </button>
                          <button
                            className="btn-accion btn-eliminar"
                            title="Eliminar local"
                            onClick={() => handleEliminarArchivoLocal(item.id)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>

                        </>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}

      <FilePreviewModal 
        isOpen={previewModalOpen}
        onClose={() => setPreviewModalOpen(false)}
        fileUrl={previewUrl}
        fileName={previewFile ? previewFile.nombre : ''}
        onDownload={previewFile ? () => handleDescargarArchivo(previewFile) : null}
      />
    </div>
  );
};

export default OneDriveAdmin;
